import { PropsFilter } from "../../../../models/api/props-filter/props-filter";
import { ListSortDirection } from "../../../../models/api/sort/list-sort-direction";
import { Sort } from "../../../../models/api/sort/sort";
import { PositionStatusDTO } from "../../../../models/recruiting/positions/position-status/position-status-dto";
import { PositionStatusSTO } from "../../../../models/recruiting/positions/position-status/position-status-sto";
import { BaseApiService } from "../../../base/base-api.service";

export class PositionStatusesApiService extends BaseApiService<PositionStatusDTO, PositionStatusSTO> {
  constructor() {
    super({
      servicePath: "/PositionStatuses",
      loadItemsPath: "/GetPositionStatuses",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadPositionStatus = async (id?: string) => {
  const response = await new PositionStatusesApiService().loadItems({
    ids: id ? [id] : [],
    createdByUsers: [],
    isDeleted: false,
    modifiedByUsers: [],
    notIds: [],
  } as PropsFilter);

  return response;
};
